import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {Linear, TimelineLite} from "gsap";


export class BonusBunniesIndividualWinAmountView extends PIXI.Container {

    private _individualWinTextContainer: PIXI.Container;

    constructor() {
        super();
        this.load()
    }


    private load(): void {
        this._individualWinTextContainer = new PIXI.Container();
        this._individualWinTextContainer.position.set(0, 0);
        this._individualWinTextContainer.name = "individualTextConTainer";
        this.addChild(this._individualWinTextContainer);
    }

    public displayIndividualBetLineAmount(linesWinsData: IBetLineWinData[]): void {
        //  debugger;
        const posArray: number[] = [];

        for (let i: number = 0; i < linesWinsData.length; i++) {
            let betLineWinData: IBetLineWinData = linesWinsData[i];
            let betLine: number[] = betLineWinData.betLine;

            const symId: number = betLine[betLineWinData.nrOfSymbols - 1];
            const basePosition: number[] = Helper.getSymbolPositions(betLineWinData.nrOfSymbols - 1, symId);

            basePosition[0] = Math.ceil(basePosition[0]);
            basePosition[1] = Math.ceil(basePosition[1]);

            const amountText: PIXI.BitmapText = new PIXI.BitmapText(Currency.formatValue(betLineWinData.multipliedAmount), {
                fontName: BonusBunniesGameConfig.TEXT_STYLES.FS_WIN_NUMBER.font.name!,
                fontSize: 20
            });
            amountText.maxWidth = 75;
            let uniqueNo: number = parseInt(basePosition[0].toString() + basePosition[1].toString());


            if (!posArray.includes(uniqueNo)) {
                posArray.push(uniqueNo);
                const amountContainer: PIXI.Container = new PIXI.Container();
                amountContainer.name = uniqueNo.toString();
                amountText.position.set(basePosition[0], basePosition[1]);

                amountText.pivot.x = amountText.textWidth * 0.5;
                amountText.pivot.y = amountText.textHeight * 0.5;
                amountContainer.addChild(amountText);
                amountContainer.alpha = 0;
                if (symId === 0) {
                    amountContainer.y -= 40
                } else if (symId === 2) {
                    amountContainer.y += 40;
                } else if (symId === 3) {
                    amountContainer.y += 20;
                }
                this._individualWinTextContainer.addChild(amountContainer);
            } else {
                let oldContainer: PIXI.Container = <PIXI.Container>this._individualWinTextContainer.getChildByName(uniqueNo.toString());
                oldContainer.addChild(amountText);
                oldContainer.children.forEach((item, index) => {
                    const displayAmount: PIXI.BitmapText = (<PIXI.BitmapText>item);
                    displayAmount.position.set(basePosition[0], basePosition[1] + 72 - index * (displayAmount.textHeight));
                    displayAmount.pivot.x = displayAmount.textWidth * 0.5;
                    displayAmount.pivot.y = displayAmount.textHeight * 0.5;
                });
            }
        }

        this._individualWinTextContainer.children.forEach((fontContainer, index: number) => {
            const oneSymContainer: PIXI.Container = <PIXI.Container>fontContainer;
            const oneTl: TimelineLite = new TimelineLite();
            oneTl.to(oneSymContainer, 0.05, {alpha: 1}, 0);
            oneTl.to(oneSymContainer.position, 0.9, {
                y: "-=30",
                ease: Linear.easeNone
            }, ">");
            oneTl.to(oneSymContainer, 0.05, {alpha: 0}, "<0.05");
        });
    }

    public individualLineAmountReset(): void {
        if (this._individualWinTextContainer.children.length > 0) {
            this._individualWinTextContainer.children.forEach((item) => {
                (<PIXI.Container>item).children.forEach((font) => {
                    font.destroy();

                });
            });
            this._individualWinTextContainer.removeChildren();
        }
    }


}